import { render } from "./EditGroupCharges.vue?vue&type=template&id=074d41bd&scoped=true"
import script from "./EditGroupCharges.vue?vue&type=script&lang=js"
export * from "./EditGroupCharges.vue?vue&type=script&lang=js"

import "./EditGroupCharges.vue?vue&type=style&index=0&id=074d41bd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-074d41bd"]])

export default __exports__